import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { BottomSheet, Card, Column, Popover, Typography } from 'seagull';
import { ColorPicker } from '~/components/ColorPicker/ColorPicker';
import { ColorSelector } from '~/components/ColorSelector/ColorSelector';
import styles from './BrandingControllers.module.scss';
import { PRESET_SOLID_COLORS } from './brandingPresetColors';
export function ColorSelectorWithPopup(props) {
    const { branding, colorKey, hasError, size, useMobileSheet, mobileSheetTitle, onChange } = props;
    const color = branding[colorKey];
    const [anchorEl, setAnchorEl] = useState(null);
    const [sheetOpen, setSheetOpen] = useState(false);
    function changeColor(newColor) {
        onChange(_object_spread_props(_object_spread({}, branding), {
            [colorKey]: newColor
        }));
    }
    const handleClick = (e)=>{
        if (useMobileSheet) {
            setSheetOpen(true);
        } else {
            setAnchorEl(e.currentTarget);
        }
    };
    const colorContent = /*#__PURE__*/ _jsxs(Column, {
        gap: 24,
        alignItems: "stretch",
        className: styles.colorSelectorPopoverContent,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.colorsGrid,
                children: PRESET_SOLID_COLORS.map((presetColor, idx)=>/*#__PURE__*/ _jsx(ColorSelector, {
                        withBorder: true,
                        color: presetColor,
                        selected: presetColor.toLowerCase() === (color || '').toLowerCase(),
                        testId: "color-preset-".concat(idx),
                        onClick: ()=>changeColor(presetColor)
                    }, presetColor))
            }),
            /*#__PURE__*/ _jsx(ColorPicker, {
                colorAsSuffix: true,
                noMinWidth: true,
                className: styles.colorPicker,
                testId: "color-picker-".concat(colorKey),
                color: color,
                displayColor: color,
                onChange: (newColor)=>changeColor(newColor)
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ColorSelector, {
                withBorder: true,
                color: color,
                hasError: hasError,
                size: size,
                testId: "color-selector-".concat(colorKey),
                onClick: handleClick
            }),
            useMobileSheet ? /*#__PURE__*/ _jsx(BottomSheet, {
                open: sheetOpen,
                onClose: ()=>setSheetOpen(false),
                children: /*#__PURE__*/ _jsxs(Column, {
                    className: styles.bottomSheetContent,
                    gap: 24,
                    children: [
                        mobileSheetTitle && /*#__PURE__*/ _jsx(Typography, {
                            variant: "h6",
                            weight: "normal",
                            className: styles.bottomSheetTitle,
                            children: mobileSheetTitle
                        }),
                        colorContent
                    ]
                })
            }) : /*#__PURE__*/ _jsx(Popover, {
                anchorEl: anchorEl,
                open: !!anchorEl,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: -5,
                    horizontal: 'right'
                },
                onClose: ()=>setAnchorEl(null),
                children: /*#__PURE__*/ _jsx(Card, {
                    className: styles.colorSelectorPopoverCard,
                    children: colorContent
                })
            })
        ]
    });
}
export function ColorSelectorWithPopupMulti(props) {
    const { branding, colorKeys, hasError, onChange } = props;
    const color = branding[colorKeys[0]];
    const [anchorEl, setAnchorEl] = useState(null);
    function changeColor(newColor) {
        const next = _object_spread({}, branding);
        colorKeys.forEach((key)=>{
            next[key] = newColor;
        });
        onChange(next);
    }
    const testId = "color-selector-".concat(colorKeys.join('-'));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ColorSelector, {
                withBorder: true,
                color: color,
                hasError: hasError,
                testId: testId,
                onClick: (e)=>setAnchorEl(e.currentTarget)
            }),
            /*#__PURE__*/ _jsx(Popover, {
                anchorEl: anchorEl,
                open: !!anchorEl,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: -5,
                    horizontal: 'right'
                },
                onClose: ()=>setAnchorEl(null),
                children: /*#__PURE__*/ _jsx(Card, {
                    className: styles.colorSelectorPopoverCard,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 24,
                        alignItems: "stretch",
                        className: styles.colorSelectorPopoverContent,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.colorsGrid,
                                children: PRESET_SOLID_COLORS.map((presetColor, idx)=>/*#__PURE__*/ _jsx(ColorSelector, {
                                        withBorder: true,
                                        color: presetColor,
                                        selected: presetColor.toLowerCase() === (color || '').toLowerCase(),
                                        testId: "color-preset-".concat(idx),
                                        onClick: ()=>changeColor(presetColor)
                                    }, presetColor))
                            }),
                            /*#__PURE__*/ _jsx(ColorPicker, {
                                colorAsSuffix: true,
                                noMinWidth: true,
                                className: styles.colorPicker,
                                testId: "color-picker-".concat(testId),
                                color: color,
                                displayColor: color,
                                onChange: (newColor)=>changeColor(newColor)
                            })
                        ]
                    })
                })
            })
        ]
    });
}
